<template>
  <div class="padding-content">
    <div class=" padding-content shadow-sm bg-gray-50">
      <div class="col-12">
        <div class="table-responsive">

          <strong>Empresas disponibles</strong>

          <br />
          <br />
          <b-table
            id="tabla-empresas"
            :items="empresas"
            :fields="columnas"
            bordered
          >
            <template v-slot:cell(asignado)="row" class="text-center">
              <b-form-checkbox v-model="row.item.asignado"/>
            </template>
          </b-table>

          <div v-if="loading" class="d-flex justify-content-center mt-3 shadow-sm bg-gray-50">
            <span class="text-muted">Cargando empresas...</span>
          </div>

        </div>
      </div>
    </div>

    <br />
    <b-row>
      <b-col>
        <button class="btn btn-secondary float-left" @click="setModalPaso(4)">Anterior</button>
        <button class="btn btn-primary float-right" @click="setModalPaso(6)">Siguiente</button>
        <button class="btn btn-secondary float-right mr-2" @click="setModalVer(false)">Cancelar</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import {mapState, mapActions, mapMutations} from "vuex";

  export default {
    name: "empresas",
    data() {
      return {
        loading: false,
        columnas: [
          {key: 'nombre', label: 'Empresa', sortable: true, thStyle: {color: '#097b83', background: '#f8f8f8'}},
          {key: 'asignado', label: 'Asignado', sortable: false, thStyle: {color: '#097b83', background: '#f8f8f8'}}
        ]
      }
    },
    mounted() {
      this.loading = true
      
      const response = this.listarEmpresas()
      response.finally(() => this.loading = false)
    },
    computed: {
      ...mapState('pasoapaso', [
        'empresas'
      ])
    },
    methods: {
      ...mapActions('pasoapaso', [
        'listarEmpresas'
      ]),
      ...mapMutations('pasoapaso', ['setModalPaso']),
    }
  }
</script>

<style>
.padding-content{
    padding: 20px;
}
</style>
